import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addIndustrialGasToBusiness = ({
  businessId,
  gas_type,
  qty,
  price_invoice,
  invoice_date,
  invoice_number,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    gas_type: gas_type.trim(),
    qty: qty,
    price_invoice: price_invoice || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/industrial-gas",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteIndustrialGas = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl + "/api/business/" + businessId + "/industrial-gas/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getIndustrialGasList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/industrial-gas",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          data.gas_type = objectifyForDropdown(data.gas_type);
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateIndustrialGas = ({
  businessId,
  objectId,
  gas_type,
  qty,
  price_invoice,
  invoice_date,
  invoice_number,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
}) => {
  var data = JSON.stringify({
    gas_type: gas_type.trim(),
    qty: qty,
    price_invoice: price_invoice || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl + "/api/business/" + businessId + "/industrial-gas/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.gas_type = objectifyForDropdown(
              response.data.data.gas_type
            );
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getIndustrialGas = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl + "/api/business/" + businessId + "/industrial-gas/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.gas_type = objectifyForDropdown(gotValue.gas_type);
            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
